import React, { useContext, useEffect, useRef, useState } from 'react'
import { FaSearch } from 'react-icons/fa'

import DateFnsUtils from '@date-io/date-fns'
import MomentUtils from '@date-io/moment'
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import moment from 'moment'
import 'moment/locale/pt-br'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Context from '../../context'
import { PUSH_TYPE_LIST } from '../../helpers/Variables'
import { createPushNotification, searchSubscription } from '../../services/ClubeApi'
import ImageUploadToS3ge from '../../services/ImageUpload'
import ProgressBar from '../ProgressBar'

moment.locale('pt-br')

const typeList = PUSH_TYPE_LIST

const { REACT_APP_IMAGES_URL } = process.env

function NotificationFormModal({ editData }) {
  const closeButton = useRef(null)
  const { setOpenToast, getPushList, setShowLoadingModal } = useContext(Context)

  const [isLoading, setIsLoading] = useState(false)
  const [check, setCheck] = useState(false)
  const [date, setDate] = useState(new Date())
  const [imageToUpload, setImageToUpload] = useState(null)
  const [objectData, setObjectData] = useState({
    body: '',
    title: '',
    image: null,
    type: 1
  })
  const [userSearch, setUserSearch] = useState('')
  const [subscriptionsList, setSubscriptionsList] = useState([])
  const [searchLoading, setSearchLoading] = useState(false)

  useEffect(() => {
    if (!objectData) return

    setObjectData({
      id: editData?.id,
      body: editData?.body || '',
      title: editData?.title || '',
      image: editData?.image || null,
      type: editData?.type || 1,
      url: (() => {
        try {
          return JSON.parse(editData?.extra)?.url
        } catch {
          return ''
        }
      })()
    })
    setDate(editData?.dateTimeSend)
    setUserSearch(editData?.ClientGazetum?.name || '')
  }, [editData])

  const handleSearchSubmit = () => {
    setSearchLoading(true)
    searchSubscription(userSearch).then(r => {
      setSubscriptionsList(r)
      setSearchLoading(false)
    })
  }

  const handleChangeDate = value => {
    setDate(value)
  }

  const handleSubmitButton = async () => {
    setShowLoadingModal(true)

    let imageUploaded = null
    if (imageToUpload !== null && typeof imageToUpload !== 'string') {
      imageUploaded = await ImageUploadToS3ge(imageToUpload, 'notifications/')
    }

    const body = {
      ...objectData,
      dateTimeSend: moment(date).format('YYYY-MM-DD HH:mm'),
      situation: editData?.situation || 9,
      data: objectData.url && objectData.url.length > 0 ? `{"url":"${objectData.url}"}` : null
    }

    if (objectData.image) {
      body.imageUrl = objectData.image
    }

    if (imageUploaded !== null) {
      body.imageUrl = `${REACT_APP_IMAGES_URL}${imageUploaded}`
    }

    let pushN = await createPushNotification(body)

    if (pushN.message)
      setOpenToast({
        open: true,
        message: pushN.message,
        type: 'error'
      })
    else
      setOpenToast({
        open: true,
        message: 'Notificação criada com sucesso.',
        type: 'success'
      })

    getPushList()
    setObjectData({
      body: '',
      title: '',
      extra: { url: null },
      image: ''
    })
    setShowLoadingModal(false)
    closeButton.current.click()
  }

  const handleCloseModal = () => {
    setObjectData({
      body: '',
      title: '',
      extra: { url: null },
      image: ''
    })
    setIsLoading(false)
  }

  const handleSelectSubscription = userData => {
    setObjectData({ ...objectData, digitalUserID: userData.digitalUserID })
    setUserSearch(userData.name)
    setSubscriptionsList([])
  }

  return (
    <div
      className="modal fade"
      id="addNotification"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addNotificationLabel"
      aria-hidden="true"
      style={{ zIndex: 1280 }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addNotificationLabel">
              Adicionar Notificação
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <ProgressBar width="100%" height="25px" marginBottom="15px" marginTop="15px" />
            ) : (
              <form
                onSubmit={e => {
                  e.preventDefault()
                  handleSearchSubmit()
                }}
              >
                <div className="form-group">
                  <label htmlFor="title">Título</label>
                  <input
                    value={objectData.title || ''}
                    onChange={e => {
                      setObjectData({ ...objectData, title: e.target.value })
                    }}
                    type="text"
                    id="title"
                    className="form-control"
                    placeholder="Título"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="url">Url</label>
                  <input
                    value={objectData.url || ''}
                    onChange={e =>
                      setObjectData({
                        ...objectData,
                        url: e.target.value
                      })
                    }
                    type="text"
                    id="url"
                    className="form-control"
                    placeholder="Url"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="body">Texto</label>
                  <textarea
                    className="form-control"
                    id="body"
                    rows="3"
                    value={objectData.body || ''}
                    onChange={e => setObjectData({ ...objectData, body: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={check}
                        onChange={() => setCheck(!check)}
                        value="check"
                        color="primary"
                      />
                    }
                    label="Fazer upload de Imagem"
                  />
                </div>

                {!check ? (
                  <div className="form-group">
                    <label htmlFor="imageUrl">Url da imagem</label>
                    <input
                      value={objectData.image || ''}
                      onChange={e =>
                        setObjectData({
                          ...objectData,
                          image: e.target.value
                        })
                      }
                      type="text"
                      id="imageUrl"
                      className="form-control"
                      placeholder="Url da imagem"
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="file">Upload Imagem</label>
                    <input
                      type="file"
                      className="form-control-file"
                      id="file"
                      accept="image/*"
                      onChange={e => setImageToUpload(e.target.files[0])}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="sendTo">Enviar para</label>
                  <select
                    className="form-control"
                    id="sendTo"
                    value={objectData.type}
                    onChange={e =>
                      setObjectData({
                        ...objectData,
                        type: Number(e.target.value)
                      })
                    }
                  >
                    {typeList.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                {objectData.type === 2 && (
                  <>
                    <label htmlFor="user">Assinante para enviar a notificação</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="João da Silva"
                        aria-label="João da Silva"
                        name="user"
                        id="user"
                        value={userSearch}
                        onChange={e => setUserSearch(e.target.value)}
                      />
                      <div className="input-group-append">
                        <button className="btn btn-outline-secondary" type="submit">
                          <FaSearch />
                        </button>
                      </div>
                    </div>

                    {searchLoading && <ProgressBar height="15px" width="100%" marginTop="10px" />}

                    {subscriptionsList.length > 0 && (
                      <div className="form-group partner-select-area">
                        {subscriptionsList.map(item => (
                          <li
                            className="item-click"
                            key={item.digitalUserID}
                            style={{ marginBottom: '10px' }}
                            onClick={() => handleSelectSubscription(item)}
                            role="presentation"
                          >
                            {item.name}
                          </li>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {objectData.type === 3 && (
                  <div className="form-group">
                    <label htmlFor="topic">Oferta / Tópico</label>
                    <input
                      value={objectData.topic || ''}
                      onChange={e => {
                        setObjectData({ ...objectData, topic: e.target.value })
                      }}
                      type="text"
                      id="topic"
                      className="form-control"
                      placeholder="Id da Oferta ou Tópico"
                    />
                  </div>
                )}

                <div className="form-group" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                  <div className="row">
                    <div className="col-6" style={{ padding: '5px' }}>
                      <MuiPickersUtilsProvider
                        libInstance={moment}
                        utils={MomentUtils}
                        locale="pt-br"
                      >
                        <KeyboardDatePicker
                          margin="normal"
                          id="date"
                          label="Data de envio"
                          format="DD/MM/YYYY"
                          minDate={new Date()}
                          value={date}
                          onChange={handleChangeDate}
                          KeyboardButtonProps={{
                            'aria-label': 'Alterar Dia'
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className="col-6" style={{ padding: '5px' }}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          ampm={false}
                          margin="normal"
                          id="time"
                          label="Hora"
                          value={date}
                          onChange={handleChangeDate}
                          KeyboardButtonProps={{
                            'aria-label': 'Alterar Hora'
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>

          <div className="modal-footer">
            {!isLoading && (
              <>
                <button
                  ref={closeButton}
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={handleCloseModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitButton}
                  disabled={isLoading}
                >
                  Salvar
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotificationFormModal
